<template lang="pug">
div
  svg.logo(:style="cssLogo" id="logo-epoca" data-name="logo-epoca" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="" viewBox="33 32.92 145.78 114.61")
    defs
      linearGradient(id="gradient" x1="1515.71" y1="111.62" x2="1464.64" y2="177.37" gradientTransform="translate(1637.23 212.26) rotate(-179.8)" gradientUnits="userSpaceOnUse")
        stop(offset="0" stop-color="#31d8b0")
        stop(offset="0.15" stop-color="#54e6a4")
        stop(offset="0.3" stop-color="#71f199")
        stop(offset="0.45" stop-color="#86f992")
        stop(offset="0.6" stop-color="#93fd8d")
        stop(offset="0.74" stop-color="#97ff8c")
        stop(offset="1" stop-color="#97ff8c")
    path.none(d="M43.05,88.21A24.85,24.85,0,0,0,43.23,68L33,78.1Z" class="green")
    path.none(d="M58.36,77.89a37.76,37.76,0,0,1-5.72,20l8.62,8.7a49.81,49.81,0,0,0,.36-56.91l-8.7,8.64A37.75,37.75,0,0,1,58.36,77.89Z" class="green")
    path.none(d="M142.65,97.78,78.45,33,71,40.37A62.86,62.86,0,0,1,70.56,116l28.76,29a8.61,8.61,0,0,0,12.19,0l45.74-45.43A11.36,11.36,0,0,1,142.65,97.78Z" class="green")
    path.none(d="M178.78,78.18,157.26,99.63a11.36,11.36,0,0,1-14.6-1.85L105.73,60.61l27.78-27.69Z" class="linear-gradient")
  //- svg.logo(v-if="withText" :style="cssLogo" id="logo-epoca" data-name="logo-epoca" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="" viewBox="0 0 387.000000 107.000000" preserveAspectRatio="xMidYMid meet")
  //-   defs
  //-   g(v-if="withText" fill="#97FF8CFF" stroke="#97FF8CFF")
  //-     path(v-if="withText" d="M 44.655 21.829 C 42.496 24.214 42.499 24.231 46.000 31.377 C 51.463 42.525 50.830 55.405 44.328 65.380 L 41.799 69.261 51.130 78.630 C 58.684 86.216 61.020 88.000 63.400 88.000 C 65.838 88.000 68.709 85.652 80.210 74.256 C 92.815 61.766 93.798 60.543 90.988 60.837 C 88.261 61.123 86.768 60.059 78.355 51.831 C 73.108 46.699 64.288 37.438 58.757 31.250 C 53.225 25.063 48.161 20.000 47.504 20.000 C 46.847 20.000 45.565 20.823 44.655 21.829")
  //-   g(v-if="withText" fill="#31D8B0FF" stroke="#31D8B0FF")
  //-     path(v-if="withText" d="M 241.241 40.995 C 228.640 48.677 233.746 68.982 248.282 68.996 C 257.585 69.005 263.500 63.177 263.500 54.000 C 263.500 49.797 262.934 47.707 261.101 45.137 C 256.791 39.093 247.528 37.161 241.241 40.995 M 253.799 48.028 C 256.814 50.836 257.448 54.233 255.618 57.771 C 253.055 62.727 247.454 63.544 243.455 59.545 C 236.466 52.557 246.577 41.299 253.799 48.028 ")
  //-   g(v-if="withText" fill="#31D8B0FF" stroke="#31D8B0FF")
  //-     path(v-if="withText" d="M 185.000 54.000 L 185.000 69.000 188.500 69.000 C 191.833 69.000 192.000 68.833 192.000 65.500 C 192.000 62.076 192.088 62.000 196.050 62.000 C 204.279 62.000 209.977 55.861 208.445 48.646 C 207.047 42.060 201.682 39.000 191.532 39.000 L 185.000 39.000 185.000 54.000 M 200.000 48.000 C 201.100 49.100 202.000 50.418 202.000 50.929 C 202.000 52.944 198.682 55.000 195.429 55.000 C 192.032 55.000 192.000 54.958 192.000 50.500 C 192.000 46.167 192.111 46.000 195.000 46.000 C 196.667 46.000 198.889 46.889 200.000 48.000 ")
  //-   g(v-if="withText" fill="#31D8B0FF" stroke="#31D8B0FF")
  //-     path(v-if="withText" d="M 134.000 54.000 L 134.000 69.000 144.500 69.000 L 155.000 69.000 155.000 65.500 L 155.000 62.000 148.500 62.000 C 142.233 62.000 142.000 61.910 142.000 59.500 C 142.000 57.111 142.267 57.000 148.000 57.000 L 154.000 57.000 154.000 53.500 L 154.000 50.000 148.000 50.000 C 142.667 50.000 142.000 49.778 142.000 48.000 C 142.000 46.205 142.667 46.000 148.500 46.000 L 155.000 46.000 155.000 42.500 L 155.000 39.000 144.500 39.000 L 134.000 39.000 134.000 54.000 ")
  //-   g(v-if="withText" fill="#31D8B0FF" stroke="#31D8B0FF")
  //-     path(v-if="withText" d="M 344.248 53.699 L 338.181 68.500 342.122 68.809 C 345.731 69.092 346.153 68.860 347.129 66.059 C 348.095 63.289 348.601 63.000 352.477 63.000 C 356.290 63.000 356.893 63.327 358.000 66.000 C 359.079 68.604 359.754 69.000 363.121 69.000 C 365.255 69.000 367.000 68.881 367.000 68.736 C 367.000 68.592 364.332 61.954 361.071 53.986 C 355.921 41.404 354.824 39.460 352.728 39.199 C 350.495 38.920 349.862 40.002 344.248 53.699 ")
  //-   g(v-if="withText" fill="#31D8B0FF" stroke="#31D8B0FF")
  //-     path(v-if="withText" d="M 297.256 40.645 C 290.012 44.216 287.316 54.921 291.823 62.214 C 295.746 68.561 304.410 70.797 311.691 67.342 C 316.103 65.249 316.828 63.383 314.236 60.792 C 312.322 58.877 312.050 58.851 309.875 60.375 C 304.188 64.358 297.000 60.721 297.000 53.860 C 297.000 47.272 304.314 43.730 309.875 47.625 C 312.050 49.149 312.322 49.123 314.236 47.208 C 316.828 44.617 316.103 42.751 311.691 40.658 C 307.303 38.575 301.465 38.570 297.256 40.645 ")
  //- .text.
  //-   EPOCA

</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    withText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssLogo() {
      return {
        width: this.width,
        height: this.height === null && this.width === null ? 200 + 'px' : this.height + 'px',
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.green
  fill #97ff8c
.linear-gradient
  fill url('#gradient')
// .text
//   font-weight 700
//   text-decoration none
//   letter-spacing 0.5rem
</style>
